import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { DocumentReglementaireState } from './state';
import { TypeDocumentReglementaire } from '@/models/TypeDocumentReglementaire';

export const getters: GetterTree<DocumentReglementaireState, RootState> = {
    getTypesDocumentsReglementaires(state) {
        return state.typesDocumentsReglementaires;
    },
    getDocumentReglementaireItems(state) {
        return state.documentReglementaire;
    },
    getAdrItems(state) {
        return state.adr;
    },
    getPriseEnChargeItems(state) {
        return state.prisesEnCharge;
    },
    getDocumentReglementaireFilterSite(state): Array<number> {
        return state.filterSite;
    },
    getDocumentReglementaireFilterDocumentType(state): Array<TypeDocumentReglementaire> {
        return state.filterDocumentType;
    },
    getDocumentReglementaireFilterGroupe(state): Array<number> {
        return state.filterGroupe;
    },
    getDocumentReglementaireFilterSousGroupe(state): Array<number> {
        return state.filterSousGroupe;
    },
    getDocumentReglementaireFilterEquipement(state): Array<number> {
        return state.filterEquipement;
    },
    getDocumentReglementaireFilterDocumentDateFrom(state): string {
        return state.filterDocumentDateFrom;
    },
    getDocumentReglementaireFilterDocumentDateTo(state): string {
        return state.filterDocumentDateTo;
    },
    getDocumentReglementairePage(state) {
        return state.page;
    },
    getDocumentReglementaireNbOfPages(state) {
        return state.nbOfPages;
    },
    getDocumentReglementaireScroll(state) {
        return state.scroll;
    },
    getDocumentReglementaireSort(state) {
        return state.sort;
    },
    getDocumentReglementaireCount(state) {
        return state.count;
    },
    getDocumentReglementaireTableHeader(state) {
        return state.tableHeader;
    },
    getAdrTableHeader(state) {
        return state.tableAdrHeader;
    },
    getPecTableHeader(state) {
        return state.tablePecHeader;
    },
    getDocumentReglementaireIsLoading(state) {
        return state.isLoading;
    },
    getZipIsLoading(state) {
        return state.isZipLoading;
    },
    getNombreDocumentModal(state): number {
        return state.nombreDocumentModal;
    },
};
